import { render, staticRenderFns } from "./logManage.vue?vue&type=template&id=99231c62&scoped=true&"
import script from "./logManage.vue?vue&type=script&lang=js&"
export * from "./logManage.vue?vue&type=script&lang=js&"
import style0 from "./logManage.vue?vue&type=style&index=0&id=99231c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99231c62",
  null
  
)

export default component.exports